import Head from "next/head";
import { BreadCrumb } from "../../../../components/BreadCrumb";
import { GuidesGrid } from "../../../../components/GuidesGrid";
import { api } from "../../../../components/helpers";
import Layout from "../../../../components/layouts/DatoDocsLayout";
import { Flex } from "@radix-ui/themes";
import { FeaturedBlogPost } from "../../../../components/FeaturedBlogPost";

export default function Guides({ guides, user, mobileMenuIsOpen, setMobileMenu, handleToast }) {
    return <><Head><link
        rel="canonical"
        href={`https://www.covalenthq.com/docs/unified-api/guides/`}
        key="canonical" /></Head><Layout user={user} mobileMenuIsOpen={mobileMenuIsOpen} setMobileMenu={setMobileMenu} handleToast={handleToast}><article>
        <BreadCrumb title={"Guides"} />
        <Flex direction="column" gap="3" mb="8">
            <h1>Guides</h1>
            <p>The following guides show you how to solve a specific problem or use case using the Covalent Unified API.</p>
        </Flex>
        <div className="FeaturedBlogPost"><FeaturedBlogPost datoposts={guides} /></div>
    </article>
    <GuidesGrid datoGuides={guides} />
    </Layout>
    <style jsx>
        {`
            article {
                max-width: var(--blog-page-max-width);
            }
            .FeaturedBlogPost {
                padding-right: 4rem;
            }
            @media screen and (max-width: 767px) {
                article {
                    max-width: none;
                }
                .FeaturedBlogPost {
                    padding-right: 0rem;
                }
                :global(.banner-image-guides .rt-Grid) {
                    display: flex;
                    flex-direction: column;
                }
                :global(.container) {
                    width: 100%;
                    max-width: none;
                }
                :global(.guide__card:first-of-type) {
                    margin-left: 1rem;
                }
                :global(.container h2) {
                    margin-left: 1rem;
                }
            }
        `}
    </style>
    </>;
}

export async function getStaticProps() {
    const guides = await api.get_all_dato_guides();
    return {
        props: {
            guides: guides.data.allGuides.filter((x) => x._status === "published"),
            component: "Guides"
        },
    };
}